/**
 * Theme layer barrel.
 *
 * Exposes the raw tokens plus the persona theme bundles (les trois univers, les versants sombres
 * des trois univers, et le thème de départ de l'app). The actual registration with
 * Unistyles happens ONCE in `../unistyles.ts` (single `StyleSheet.configure` call) — this file
 * only assembles and re-exports.
 */
export * from "./tokens"

export { baseTheme } from "./base"
export type { AppTheme } from "./base"
export { initialTheme } from "./initial"
export { studentTheme } from "./student"
export { studentDarkTheme } from "./studentDark"
export { parentTheme } from "./parent"
export { parentDarkTheme } from "./parentDark"
export { tutorTheme } from "./tutor"
export { tutorDarkTheme } from "./tutorDark"
export { DARK_THEME_NAMES, isDarkThemeName } from "./scheme"
export type { ColorScheme } from "./scheme"
